(function () {
  'use strict';

  function eligibleSources(detail, maximum, exchange) {
    if (!detail || detail.source !== 'storefront' || !(maximum > 0) || !detail.cart) return [];
    var candidates = [];
    var items = detail.cart.items || [];
    for (var added of detail.items || []) {
      var quantity = Number(added.quantity == null ? 1 : added.quantity);
      if (!Number.isInteger(quantity) || quantity < 1 || added.selling_plan) continue;
      var matches = items.filter(function (item) {
        return !item.selling_plan_allocation && exchange.sameLine(item, {
          variant_id: added.id, properties: added.properties || {}
        });
      });
      if (matches.length !== 1) continue;
      var source = matches[0];
      var properties = source.properties || {};
      var unitPrice = Number(source.final_price != null ? source.final_price : Number(source.final_line_price) / source.quantity);
      if (properties._gd_reward_gift === 'true' || properties._gota_brinde === 'true' ||
          properties._gd_kit_exchange || !(unitPrice > 0 && unitPrice <= maximum) ||
          quantity > Number(source.quantity) ||
          /\bkits?\b/i.test(source.product_title || source.title || '') ||
          /\bkit\b/i.test(source.product_type || '')) continue;
      candidates.push({ source: source, quantity: quantity, currency: detail.cart.currency });
    }
    return candidates;
  }

  function chooseOffer(detail, kits, maximum, exchange) {
    for (var candidate of eligibleSources(detail, maximum, exchange)) {
      var kit = window.GDKitMatching.findKit(candidate.source, kits);
      if (kit) return Object.assign({}, candidate, { kit: kit });
    }
    return null;
  }

  function sourcePrice(offer) {
    var source = offer && offer.source;
    return source ? Number(source.final_price != null ? source.final_price : Number(source.final_line_price) / source.quantity) : 0;
  }

  function canShowForPrice(price) {
    if (!Number.isFinite(price) || price <= 0) return false;
    try {
      var saved = window.sessionStorage.getItem('gd-kit-suggestion-price');
      var previous = saved == null ? 0 : Number(saved);
      if (!Number.isFinite(previous) || previous < 0) return false;
      return price > Math.max(previous, Number(window.__gdKitSuggestionPrice || 0));
    } catch (error) { return false; }
  }

  function claimThisVisit(price) {
    if (!canShowForPrice(price)) return false;
    try {
      window.sessionStorage.setItem('gd-kit-suggestion-price', String(price));
      window.__gdKitSuggestionPrice = price;
      return true;
    } catch (error) {
      console.warn('Sugestão de Kit: não foi possível salvar o valor da última oferta.');
      return false;
    }
  }

  if (window.__GD_KIT_TEST_HOOK__) window.__GD_KIT_TEST_HOOK__({
    chooseOffer: chooseOffer, eligibleSources: eligibleSources,
    canShowForPrice: canShowForPrice, claimThisVisit: claimThisVisit
  });
  var config = document.querySelector('[data-gd-kit-config]');
  var root = document.querySelector('[data-gd-kit-suggestion]');
  var shared = window.GDThemeShared;
  var exchange = window.GDKitExchange;
  if (!config || !root || !shared || !exchange || !window.GDKitMatching ||
      !config.dataset.collection || config.dataset.enabled !== 'true' || config.dataset.designMode === 'true') return;
  if (config.dataset.bound === 'true') return;
  config.dataset.bound = 'true';
  var catalogCache;

  async function loadCatalog(signal) {
    if (catalogCache && Date.now() - catalogCache.created < 60000) return catalogCache.promise;
    var promise = (async function () {
      var url = new URL(shared.rootUrl + 'collections/' + encodeURIComponent(config.dataset.collection), window.location.origin);
      url.searchParams.set('section_id', 'gd-kit-catalog');
      var visited = new Set();
      var kits = [];
      while (url && !visited.has(url.href) && visited.size < 100) {
        visited.add(url.href);
        var response = await fetch(url.href, { credentials: 'same-origin', signal: signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Não foi possível consultar a coleção Kits.');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var catalog = doc.querySelector('[data-gd-kit-catalog]');
        if (!catalog) throw new Error('O catálogo automático de kits não está instalado.');
        catalog.querySelectorAll('[data-gd-kit-product]').forEach(function (node) {
          kits.push({
            id: node.dataset.id, title: node.dataset.title, handle: node.dataset.handle,
            description: node.dataset.description, tags: JSON.parse(node.dataset.tags || '[]'), image: node.dataset.image,
            variants: Array.from(node.querySelectorAll('[data-gd-kit-option]')).map(function (variant) {
              return { id: Number(variant.dataset.variantId), price: Number(variant.dataset.price), title: variant.dataset.title, available: true };
            }).filter(function (variant) { return variant.id > 0 && variant.price > 0; })
          });
        });
        if (!catalog.dataset.nextUrl) break;
        var next = new URL(catalog.dataset.nextUrl, url);
        if (next.origin !== url.origin || next.pathname !== url.pathname) throw new Error('Paginação inválida da coleção Kits.');
        next.searchParams.set('section_id', 'gd-kit-catalog');
        url = next;
      }
      return kits;
    })().catch(function (error) {
      if (catalogCache && catalogCache.promise === promise) catalogCache = null;
      throw error;
    });
    catalogCache = { created: Date.now(), promise: promise };
    return promise;
  }

  async function lookup(detail, candidates, expectedRevision) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 5000);
    try {
      var kits = await loadCatalog(controller.signal);
      for (var candidate of candidates) {
        if (revision !== expectedRevision) return null;
        var source = candidate.source;
        var handle = source.handle;
        if (!handle && source.url) {
          var match = new URL(source.url, window.location.origin).pathname.match(/\/products\/([^/]+)/);
          if (match) handle = decodeURIComponent(match[1]);
        }
        var metadata = source;
        if (handle) {
          try {
            var response = await fetch(shared.rootUrl + 'products/' + encodeURIComponent(handle) + '.js', {
              credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
            });
            if (response.ok) {
              var product = await response.json();
              if (String(product.id) === String(source.product_id)) metadata = Object.assign({}, source, {
                handle: product.handle || handle, tags: product.tags, product_title: product.title || source.product_title
              });
            }
          } catch (error) {
            if (controller.signal.aborted) throw error;
            // Title matching still works when optional tag metadata is unavailable.
          }
        }
        if (revision !== expectedRevision || controller.signal.aborted) return null;
        var kit = window.GDKitMatching.findKit(metadata, kits);
        if (kit) return Object.assign({}, candidate, { kit: kit });
      }
      return null;
    } finally { window.clearTimeout(timeout); }
  }
  var dialog = root.querySelector('[data-gd-kit-dialog]');
  var select = root.querySelector('[data-gd-kit-variant]');
  var accept = root.querySelector('[data-gd-kit-accept]');
  var close = root.querySelector('[data-gd-kit-close]');
  var status = root.querySelector('[data-gd-kit-status]');
  var busy = false;
  var active;
  var previousFocus;
  var revision = 0;
  var timer;

  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    accept.setAttribute('aria-busy', String(value));
    accept.disabled = value;
    select.disabled = value;
    close.disabled = value;
    accept.textContent = value ? 'Trocando pelo kit…' : 'Trocar pelo kit';
  }

  function dismiss() {
    if (busy || !dialog.open) return;
    dialog.close();
    document.documentElement.classList.remove('gd-orderbump-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    active = null;
  }

  function updatePrice() {
    if (!active) return;
    var variant = active.kit.variants.find(function (item) { return String(item.id) === select.value; });
    if (variant) root.querySelector('[data-gd-kit-price]').textContent = shared.money(variant.price * active.quantity, active.currency);
  }

  function open(offer, expectedRevision) {
    if (!canShowForPrice(sourcePrice(offer)) || revision !== expectedRevision || busy || document.querySelector('dialog[open]') ||
        typeof dialog.showModal !== 'function') return;
    active = offer;
    root.querySelector('[data-gd-kit-original]').textContent = offer.quantity + ' × ' + (offer.source.product_title || offer.source.title);
    root.querySelector('[data-gd-kit-title]').textContent = offer.kit.title;
    root.querySelector('[data-gd-kit-quantity]').textContent = String(offer.quantity);
    var image = root.querySelector('[data-gd-kit-image]');
    image.hidden = !offer.kit.image;
    if (offer.kit.image) { image.src = offer.kit.image; image.alt = offer.kit.title; }
    else image.removeAttribute('src');
    select.replaceChildren();
    offer.kit.variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = String(variant.id);
      option.textContent = variant.title === 'Default Title' ? offer.kit.title : variant.title;
      select.appendChild(option);
    });
    select.closest('label').hidden = offer.kit.variants.length < 2;
    status.textContent = '';
    status.classList.remove('is-error');
    close.textContent = 'Continuar com o produto avulso';
    setBusy(false);
    updatePrice();
    previousFocus = document.activeElement;
    if (!claimThisVisit(sourcePrice(offer))) return;
    dialog.showModal();
    document.documentElement.classList.add('gd-orderbump-open');
    accept.focus({ preventScroll: true });
  }

  select.addEventListener('change', updatePrice);
  close.addEventListener('click', dismiss);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  document.addEventListener('keydown', function (event) {
    if (!dialog.open || (event.key !== 'Tab' && event.key !== 'Escape')) return;
    event.stopImmediatePropagation();
    if (event.key === 'Escape') { event.preventDefault(); dismiss(); return; }
    var controls = Array.from(dialog.querySelectorAll('button:not(:disabled),select:not(:disabled)')).filter(function (node) {
      return node.getClientRects().length > 0;
    });
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); dialog.focus(); return; }
    if (!dialog.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) ||
        (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }, true);

  accept.addEventListener('click', async function () {
    if (!active || busy) return;
    var variant = active.kit.variants.find(function (item) { return String(item.id) === select.value; });
    if (!variant) return;
    var transaction = {
      source: active.source, quantity: active.quantity, variantId: variant.id,
      token: 'kit-' + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2))
    };
    setBusy(true);
    status.classList.remove('is-error');
    status.textContent = 'Confirmando o kit e trocando apenas a quantidade recém-adicionada…';
    try {
      var cart = await shared.gdCart.transaction(function (api) { return exchange.replace(api, transaction); });
      if (document.querySelector('[data-gd-cart-drawer].is-open')) shared.renderDrawerFast(cart);
      setBusy(false);
      dismiss();
      shared.showToast('Produto avulso substituído pelo kit.');
    } catch (error) {
      setBusy(false);
      status.classList.add('is-error');
      status.textContent = error.message || 'Não foi possível trocar. O produto avulso foi mantido.';
      if (error.reviewRequired) {
        accept.disabled = true;
        select.disabled = true;
        close.textContent = 'Fechar e conferir carrinho';
      }
      // Refresh the visible drawer even after a successful rollback.
      if (document.querySelector('[data-gd-cart-drawer].is-open')) {
        shared.request(shared.rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(shared.renderDrawerFast).catch(function () {});
      }
    }
  });

  document.addEventListener('gd:cart:updated', function () {
    revision += 1;
    window.clearTimeout(timer);
    if (!busy) dismiss();
  });
  document.addEventListener('gd:cart:added', function (event) {
    var detail = event.detail;
    var candidates = eligibleSources(detail, Number(config.dataset.maxPrice), exchange).filter(function (candidate) {
      return canShowForPrice(sourcePrice(candidate));
    });
    if (!candidates.length || busy) return;
    window.clearTimeout(timer);
    var expectedRevision = revision;
    // OrderBump waits only for this optional lookup, never the primary cart.
    detail.kitSuggestionLookup = lookup(detail, candidates, expectedRevision).then(function (offer) {
      if (!offer || !canShowForPrice(sourcePrice(offer)) || revision !== expectedRevision || busy) return false;
      detail.kitSuggestionClaimed = true;
      timer = window.setTimeout(function () { open(offer, expectedRevision); }, 0);
      return true;
    }).catch(function (error) {
      console.warn('Sugestão de Kit indisponível:', error.message);
      return false;
    });
  });
})();
